import React, { useEffect, useContext, useState } from 'react';
import classNames from 'classnames';
import { getPendantColor } from '../../utils/color';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import ReactSVG from 'react-svg';

interface IMoreButton {
  onShow: () => void;
  onHide: () => void;
  expand: boolean;
  setExpand: (e: boolean) => void;
}

const LangButton = (props: IMoreButton) => {
  const { onShow, onHide, expand, setExpand } = props;
  return (
    <NormalButton
      className={classNames({
        expand: expand,
        [`pendant-more`]: true
      })}
      onClick={() => {
        if (expand) {
          onHide();
        } else {
          onShow();
        }

        setExpand(!expand);
      }}
    >
      <ReactSVG
        src={require('../../svg/pendant-more.svg')}
        style={{ width: 18, height: 18 }}
      />
    </NormalButton>
  );
};

export default LangButton;
